var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ib-application",
    { attrs: { row: "", translations: _vm.translations } },
    [_c("FxQuotes")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }